import { render, staticRenderFns } from "./Enclosure.vue?vue&type=template&id=34be6e19&scoped=true&"
import script from "./Enclosure.vue?vue&type=script&lang=js&"
export * from "./Enclosure.vue?vue&type=script&lang=js&"
import style0 from "./Enclosure.vue?vue&type=style&index=0&id=34be6e19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34be6e19",
  null
  
)

export default component.exports